module.exports = {
          srcSet: __webpack_public_path__ + "e2a04e0c7245c362574bb7f4ef1ef8c8-69.png"+" 69w",
          images:[ {path: __webpack_public_path__ + "e2a04e0c7245c362574bb7f4ef1ef8c8-69.png",width: 69,height: 68}],
          src: __webpack_public_path__ + "e2a04e0c7245c362574bb7f4ef1ef8c8-69.png",
          toString:function(){return __webpack_public_path__ + "e2a04e0c7245c362574bb7f4ef1ef8c8-69.png"},
          
          width: 69,
          height: 68
        }